export async function uploadFileAsync(bucket: string, path: string, file: File) {
  const supabase = useSupabaseClient()
  // Step 1: Check if bucket exists for org
  const {data: orgBucket, error: bucketListError} = await supabase.storage.getBucket(bucket);

  if (bucketListError) {
    console.warn('Bucket was not available. Creating...');
    await supabase.storage.createBucket(bucket, {
      public: true,
      // TODO: set app file size limit?
    });
  }

  return await supabase.storage.from(bucket).upload(path, file, {
    cacheControl: '3600',
    upsert: false
  });
}

export type UpsertArgs = {
  bucket: string;
  path: string;               // e.g. "icons/app.png"
  file: Blob | ArrayBuffer | Buffer | ReadableStream<any>;
  contentType?: string;       // default "image/png"
  cacheControl?: string;      // e.g. "3600"
  upsert?: boolean;           // default true
};

export async function upsertFile({
  bucket,
  path,
  file,
  contentType = "image/png",
  cacheControl = "3600",
  upsert = true,
}: UpsertArgs): Promise<{ publicUrl: string }> {
  const supabase = useSupabaseClient()
  const { error } = await supabase
      .storage
      .from(bucket)
      .upload(path, file as any, { contentType, cacheControl, upsert });

  if (error) {
    // If file exists and upsert=false, you’d see 409 Conflict here.
    throw new Error(`Upload failed: ${error.message}`);
  }

  const { data } = supabase.storage.from(bucket).getPublicUrl(path);
  return { publicUrl: data.publicUrl };
}